import Vue from 'vue';
import Router from 'vue-router';
import { constantRouterMap } from './router.config';

// hack router push callback
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

export default new Router({
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    // Opening/minimizing consultation changes a query flag, not the section.
    if (to.path === from.path && to.query.anch === from.query.anch) return false;
    const sections = ['#col', '#services', '#solutions', '#about'];
    // Older contact/process links now lead to the company introduction.
    const section = ['#contact', '#process'].includes(to.query.anch) ? '#about' : to.query.anch;
    if (to.path === '/index' && sections.includes(section)) {
      // Wait for the asynchronously loaded home component to render.
      return new Promise((resolve) => {
        setTimeout(() => resolve({ selector: section, offset: { y: 84 } }), 100);
      });
    }
    return { y: 0 };
  },
  routes: constantRouterMap,
});
